import { authRoleAccess } from 'auth/AuthRoleAccess'
import { lazy } from 'react'


const CaseOfficerPerformanceDashboard = lazy(() => import ('./CaseOfficer/OfficerPerformanceDashboard'))
const CaseManagerPerformanceDashboard = lazy(() => import ('./CaseManager/OfficerPerformanceDashboard'))

const DataSetupRoutes = [
    {
        path: '/CaseOfficer_performance_dashboard',
        component: CaseOfficerPerformanceDashboard,
        auth: authRoleAccess.case_officer_dashboard,
    },
    {
        path: '/CaseManager_performance_dashboard',
        component: CaseManagerPerformanceDashboard,
        auth: authRoleAccess.case_manager_dashboard,
    },
]

export default DataSetupRoutes 